import { ReactElement } from 'react';
import { RowCollectionLayout } from '../ItvRowCollection/layouts/types';
import { ItvCollectionType } from '../types';

const CONTENT_TYPE_LABEL: Record<ItvCollectionType, string> = {
  games: 'Games',
  bingo: 'Bingo',
  promotions: 'Promotions',
  'bingo+game': 'Bingo & Games',
  recently_played_games: 'Recently Played',
  shop_products: 'Products',
};

export const getPlaceholder = (type: ItvCollectionType, layoutType: RowCollectionLayout): ReactElement => (
  <div className="itv-row-collection__placeholder">
    <p className="itv-row-collection__placeholder-title">{CONTENT_TYPE_LABEL[type]} content placeholder</p>
    <p className="itv-row-collection__placeholder-copy">
      Pass children to ItvRowCollection to populate the "{layoutType}" layout.
    </p>
  </div>
);
